export default "__VITE_ASSET__55d046d9__"